import api from "../axios";


/*
|--------------------------------------------------------------------------
| CREATE PAYMENT ORDER
|--------------------------------------------------------------------------
|
| Authenticated payment order.
|
| POST /api/payments/orders
|
*/

export const createPaymentOrder = async (
  offerId,
  gateway = "razorpay"
) => {

  const response =
    await api.post(
      "/payments/orders",
      {
        offerId,
        gateway,
      }
    );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| CREATE PUBLIC PAYMENT ORDER
|--------------------------------------------------------------------------
|
| Public customer payment order.
|
| POST /api/payments/public/:token/orders
|
| IMPORTANT:
|
| The frontend does NOT send offerId.
| The backend resolves:
|
| token
|   ↓
| public offer link
|   ↓
| offer
|   ↓
| amount
|
*/

export const createPublicPaymentOrder = async (
  token,
  gateway = "razorpay"
) => {

  if (
    !token ||
    typeof token !== "string"
  ) {
    throw new Error(
      "Public payment token is required."
    );
  }


  const response =
    await api.post(
      `/payments/public/${encodeURIComponent(token)}/orders`,
      {
        gateway,
      }
    );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| VERIFY PAYMENT
|--------------------------------------------------------------------------
|
| Authenticated payment verification.
|
| POST /api/payments/verify
|
*/

export const verifyPayment = async (
  data
) => {

  const response =
    await api.post(
      "/payments/verify",
      data
    );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| VERIFY PUBLIC PAYMENT
|--------------------------------------------------------------------------
|
| Public customer payment verification.
|
| POST /api/payments/public/:token/verify
|
*/

export const verifyPublicPayment = async (
  token,
  data
) => {

  if (
    !token ||
    typeof token !== "string"
  ) {
    throw new Error(
      "Public payment token is required."
    );
  }


  const response =
    await api.post(
      `/payments/public/${encodeURIComponent(token)}/verify`,
      data
    );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| LIST PAYMENTS
|--------------------------------------------------------------------------
*/

export const getPayments = async (
  params = {}
) => {

  const response =
    await api.get(
      "/payments",
      {
        params,
      }
    );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| GET PAYMENT
|--------------------------------------------------------------------------
*/

export const getPayment = async (
  id
) => {

  const response =
    await api.get(
      `/payments/${id}`
    );


  return response.data;
};
